import { render, staticRenderFns } from "./ModalImportExam.vue?vue&type=template&id=32eeee0a&scoped=true"
import script from "./ModalImportExam.vue?vue&type=script&lang=js"
export * from "./ModalImportExam.vue?vue&type=script&lang=js"
import style0 from "./ModalImportExam.vue?vue&type=style&index=0&id=32eeee0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32eeee0a",
  null
  
)

export default component.exports